export default function Loader({ className }: { className?: string }) {
  return (
    <div className={`loader ${className || ''}`}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
